import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import { getInvoiceWarning } from '../constants';

const InvoiceDetailAlert = ({ invoice }) => {
  const warning = getInvoiceWarning(invoice);
  if (!warning) return null;

  return (
    <Alert severity="warning" sx={{ borderRadius: 2, alignItems: 'center' }}>
      <AlertTitle sx={{ fontWeight: 700 }}>{warning.alert.title}</AlertTitle>
      <Typography variant="small_2">{warning.alert.message}</Typography>
    </Alert>
  );
};

InvoiceDetailAlert.propTypes = {
  invoice: PropTypes.shape({
    siiStatus: PropTypes.string,
    creditNoteStatus: PropTypes.string,
  }),
};

InvoiceDetailAlert.defaultProps = {
  invoice: null,
};

export default InvoiceDetailAlert;
